var map = {
	"./WhatsApp Image 2025-01-09 at 20.05.28 (1).jpeg": 833,
	"./WhatsApp Image 2025-01-09 at 20.05.28.jpeg": 699,
	"./WhatsApp Image 2025-01-09 at 20.05.29 (1).jpeg": 222,
	"./WhatsApp Image 2025-01-09 at 20.05.29 (2).jpeg": 881,
	"./WhatsApp Image 2025-01-09 at 20.05.29.jpeg": 12,
	"./WhatsApp Image 2025-01-09 at 20.05.30 (1).jpeg": 764,
	"./WhatsApp Image 2025-01-09 at 20.05.30.jpeg": 42,
	"./WhatsApp Image 2025-01-09 at 20.05.31 (1).jpeg": 759,
	"./WhatsApp Image 2025-01-09 at 20.05.31.jpeg": 897,
	"./WhatsApp Image 2025-01-09 at 20.05.32 (1).jpeg": 354,
	"./WhatsApp Image 2025-01-09 at 20.05.32.jpeg": 752,
	"./WhatsApp Image 2025-01-09 at 20.05.33 (1).jpeg": 805,
	"./WhatsApp Image 2025-01-09 at 20.05.33.jpeg": 999,
	"./WhatsApp Image 2025-01-09 at 20.05.34 (1).jpeg": 528,
	"./WhatsApp Image 2025-01-09 at 20.05.34.jpeg": 862,
	"./WhatsApp Image 2025-01-09 at 20.05.35.jpeg": 877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;